import React from 'react';
import { Header } from './Header';
import { BottomNav } from './BottomNav';

export const Layout = ({ children }) => {
  return (
    <div className="app">
      <Header />
      <div className="mobile-page">{children}</div>
      <BottomNav />
    </div>
  );
};
